"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CardHeader = _interopRequireDefault(require("./styles/CardHeader"));
var _cardStyling = _interopRequireDefault(require("./styles/cardStyling"));
var _linkArrow = _interopRequireDefault(require("@ux/icon/link-arrow"));
var _sharedComponents = require("@site/shared-components");
const CardHeader = ({
  card,
  style
}) => {
  const {
    imageSize = 'large',
    cardBorderRadius = 'medium',
    containerClassName,
    cta,
    isMobile,
    backgroundColor,
    textColor,
    disableContentCenter,
    orientation,
    disableLeftPanel,
    leftImage,
    rightImage,
    tag,
    title,
    description,
    testId = 'cardHeaderWrapper',
    dataCy = 'cardHeaderWrapper'
  } = card;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CardHeader.default, containerClassName),
    style: {
      ...style
    },
    "data-testid": testId,
    "data-cy": dataCy
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.ConditionalAnchor, {
    linkUrl: cta?.url,
    underlined: false,
    dataTestid: "cardHeaderLink",
    className: "card-header-link"
  }, /*#__PURE__*/_react.default.createElement(_cardStyling.default, {
    className: (0, _classnames.default)('border', {
      'p-3': isMobile,
      'p-4': !isMobile,
      'card-header-rounded-container py-5': cardBorderRadius === 'large'
    }),
    backgroundColor: backgroundColor,
    textColor: textColor,
    "data-testid": "cardHeaderContainer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "card-body d-flex align-items-center p-0"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'grid-card-one-column': isMobile || orientation === 'vertical',
      'grid-card': !disableContentCenter && !isMobile || orientation === 'horizontal',
      'grid-card-without-left': disableLeftPanel
    }),
    "data-testid": "cardHeader",
    "data-cy": "cardHeader"
  }, !disableLeftPanel && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('d-flex align-items-center', {
      'justify-content-center': !disableContentCenter
    })
  }, leftImage && /*#__PURE__*/_react.default.createElement("img", {
    src: leftImage,
    alt: "card",
    className: (0, _classnames.default)({
      'card-header-image': imageSize === 'large',
      'card-header-smaller-image': imageSize === 'medium',
      'card-header-smaller-image-mobile': imageSize === 'small'
    }),
    "data-cy": "cardHeaderLeftImage"
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "cardHeaderBody",
    className: (0, _classnames.default)('d-flex', 'card-header-body-p align-items-center', {
      'justify-content-center align-items-center': !disableContentCenter
    })
  }, /*#__PURE__*/_react.default.createElement("div", null, tag && /*#__PURE__*/_react.default.createElement("div", {
    className: `d-flex ${!disableContentCenter && 'justify-content-center'}`
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "card-header-tag",
    "data-cy": "cardHeaderTag"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: tag
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('pb-2', {
      'd-flex justify-content-center align-items-center': !disableContentCenter
    }),
    "data-cy": "cardHeaderTitleContainerWrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'card-header-title-max-width': !disableContentCenter
    }),
    "data-cy": "cardHeaderTitleContainer"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: (0, _classnames.default)('font-weight-bold', {
      'card-header-title text-center': !disableContentCenter
    }),
    "data-cy": "cardHeaderTitle"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: title
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex p"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('card-header-description', {
      'text-center': !disableContentCenter
    })
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: description
  }))), cta?.text && /*#__PURE__*/_react.default.createElement("span", {
    className: "d-flex p align-items-center pt-3"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('card-header-cta', {
      'text-center': !disableContentCenter
    })
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: cta.text
  })), cta?.icon || /*#__PURE__*/_react.default.createElement(_linkArrow.default, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('d-flex align-items-center', {
      'justify-content-center': !disableContentCenter,
      'justify-content-end': disableLeftPanel && !isMobile
    })
  }, rightImage && /*#__PURE__*/_react.default.createElement("img", {
    src: rightImage,
    alt: "card",
    "data-testid": "cardHeaderRightImage",
    "data-cy": "cardHeaderRightImage",
    className: (0, _classnames.default)({
      'card-header-image': imageSize === 'large',
      'card-header-smaller-image': imageSize === 'medium',
      'card-header-smaller-image-mobile': imageSize === 'small'
    })
  })))))));
};
CardHeader.propTypes = {
  style: _propTypes.default.object,
  card: _propTypes.default.shape({
    tag: _propTypes.default.string,
    title: _propTypes.default.string.isRequired,
    leftImage: _propTypes.default.string,
    rightImage: _propTypes.default.string,
    description: _propTypes.default.string.isRequired,
    disableContentCenter: _propTypes.default.bool,
    isMobile: _propTypes.default.bool,
    containerClassName: _propTypes.default.string,
    backgroundColor: _propTypes.default.string,
    textColor: _propTypes.default.string,
    orientation: _propTypes.default.string,
    imageSize: _propTypes.default.string,
    cardBorderRadius: _propTypes.default.string,
    disableLeftPanel: _propTypes.default.bool,
    cta: _propTypes.default.shape({
      text: _propTypes.default.string,
      url: _propTypes.default.string,
      icon: _propTypes.default.node
    }),
    testId: _propTypes.default.string,
    dataCy: _propTypes.default.string
  }).isRequired
};
var _default = exports.default = CardHeader;